import { Calculate, Dashboard, Newspaper, SupportAgent } from "@mui/icons-material";
import { Box, Grid2, Typography } from "@mui/material";
import FeatureCard from "./feature-card";

const features = [
    {
        title: 'Metrics Calculator',
        icon: <Calculate/>,
        overview: 'Instantly calculate and interpret key nutritional metrics such as body mass index (BMI), waist-to-hip ration (WHR), and body fat percentage (BFP), including, nutrient composition and energy (kcal/Kilojoule) values of food.',
        url: '/metrics-calculator',
        available: true
    },
    {
        title: 'NutriAI',
        icon: <SupportAgent/>,
        overview: 'An AI powered agent, primarily trained on the founder\'s Nutrition Science pamphlet: <b>Personalized Nutrition: Way forward: for healthy living</b>.',
        url: '/nutri-ai',
        available: true
    },
    {
        title: 'Blog',
        icon: <Newspaper/>,
        overview: 'A blog where articles on nutrition and healthy living principles are shared.',
        url: 'https://blog.nutriedu.com.ng',
        available: true
    },
    {
        title: 'Coaching Hub',
        icon: <Dashboard/>,
        overview: 'A personal space where you can join my live sessions, get daily guidance, access helpful resources, and stay on track with your healthy living journey.',
        url: 'https://students.elms.ng/enroll/HytCQvey',
        available: true
    }
];

function Features() {
    return (
        <Box
            sx={{
                backgroundColor: 'grey.900',
                marginTop: 5,
                display: 'flex',
                flexDirection: 'column',
                padding: 2
            }}
        >

            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center'}}>
                <Typography
                    sx={{
                        fontFamily: 'Fredoka One, sans-serif',
                        color: 'grey.100',
                        marginBottom: '20px',
                        fontSize: '1.7rem',
                    }}
                >
                    Features
                </Typography>
                
                <Grid2 container spacing={2} maxWidth="md" justifyContent="center" >
                    {
                        features.map((feature, index) => (
                            <Grid2 item size={{ xs: 12, sm: 4}} key={index}>
                                <FeatureCard title={feature.title} icon={feature.icon}
                                    overview={feature.overview} url={feature.url} availability={feature.available}/>
                            </Grid2>
                        ))
                    }
                </Grid2>
            </Box>
            
           

        </Box>
    );
}

export default Features;